<template>
    <PopupRouterViewDetail label="Delivery Order Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Delivery Order" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="DO Number" :model="model.doNumber" />
						<app-input-datepicker  id="fieldset-do-date" label-cols-lg="12"  label="DO Date" size="sm" :model.sync="model.doDate" :isRequired="false" :state="validateState('doDate')" :errorMessage="getErrorMessage(errorMessage.doDate, 'doDate')"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isUpdatable="true" :isEditable="false"/>
						<!-- <app-input-combobox-autocomplete :options="deliveryOrderStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Delivery Order Status" id="fieldset-delivery-order-status" size="sm" :model.sync="model.deliveryOrderStatusId"   :selected="model.deliveryOrderStatus != null ? model.deliveryOrderStatus.name : ''" @input="getDeliveryOrderStatuss"  :isUpdatable="true"  :isSelectMethodExists="true" @onSelectMethod="setSelectedDeliveryOrderStatus" :isEditable="false"/> -->
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Customer" id="fieldset-customer" size="sm" :model.sync="model.customerId" :isRequired="false" :state="validateState('customerId')" :errorMessage="getErrorMessage(errorMessage.customerId, 'customerId')"   :selected="model.customer != null ? model.customer.code : ''" @input="getCustomers" @change="updateData"  :isUpdatable="true"  :isSelectMethodExists="true" @onSelectMethod="setSelectedCustomer" :isEditable="false"/>
						<app-input-textarea id="fieldset-remarks" label-cols-lg="12"  label="Remarks" label-for="input-remarks" size="sm" :model.sync="model.remarks"  :isUpdatable="true" :isEditable="false"/>
				</b-col>

            </b-row>
        </b-card>

		<app-table-input-popup title="Delivery Order Details" :bordered="true" :items="deliveryOrderDetails" :fields="fieldsDeliveryOrderDetail" :busy="isDataLoading" :sort-by.sync="sortByDeliveryOrderDetail" :sort-desc.sync="sortDescDeliveryOrderDetail" small responsive
			@editButtonMethod="editRowDataDeliveryOrderDetail"
			@deleteButtonMethod="deleteRowDataDeliveryOrderDetail"
			@showPopupAddMethod="resetDataDeliveryOrderDetail()"
			@showPopupUploadMethod="showPopupUploadDeliveryOrderDetail()"
			@downloadMethod="downloadDeliveryOrderDetail()"
			@addFromClipboardMethod="addFromClipboardDeliveryOrderDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardDeliveryOrderDetail()"
			:showActionButton="true"
			:showEditButton="false"
			:showDeleteButton="true"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="true"
			:showDownloadButton="true"
			:isDownloadBusy="isDownloadDeliveryOrderDetail"
			>
			<template #top-row v-if="isShowDeliveryOrderDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="PO Number">
					<b-form-input id="input-po-number-table" v-model="filterDeliveryOrderDetail.poNumber" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Part">
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" id="filter-part-heading" label-cols-lg="12" label="Part" size="sm" :model.sync="filterDeliveryOrderDetail.partId" @change="getDeliveryOrderDetails"  @input="getParts" :loading="isPartComboLoading" :nolabel="true" />
					<!-- <v-select append-to-body label="partNumber" item-text="partNumber" item-value="id" :options="parts" :reduce="item => item.id" v-model="filterDeliveryOrderDetail.partId" @search="getParts" :filterable="true"></v-select> -->
					<!-- <v-select append-to-body label="partNumber" :options="parts" :value="filterDeliveryOrderDetail.partId" :reduce="item => item.id" v-model="filterDeliveryOrderDetail.partId" @search="getParts" :filterable="true"></v-select> -->
				</b-th>
				<b-th stacked-heading="QtyPerUnit">
					<b-form-input id="input-qty-per-unit-table" v-model="filterDeliveryOrderDetail.qtyPerUnit" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Uom">
					<app-input-combobox-autocomplete :options="uoms" optionsLabel="code" optionsKey="id" id="filter-uom-heading" label-cols-lg="12" label="Uom" size="sm" :model.sync="filterDeliveryOrderDetail.uomId" @change="getDeliveryOrderDetails"  @input="getUoms" :loading="isUomComboLoading" :nolabel="true" />
					<!-- <v-select append-to-body label="partNumber" :options="uoms"  :value="filterDeliveryOrderDetail.uomId" :reduce="item => item.id" v-model="filterDeliveryOrderDetail.uomId" @search="getParts" :filterable="true"></v-select> -->
				</b-th>
				<b-th stacked-heading="PartDestination">
					<app-input-combobox-autocomplete :options="partDestinationsForFilter" optionsLabel="destinationCode" optionsKey="id" id="filter-part-destination-heading" label-cols-lg="12" label="Part Destination" size="sm" :model.sync="filterDeliveryOrderDetail.partDestinationId" @input="getPartDestinationsForFilter"  @change="getDeliveryOrderDetails" :nolabel="true" />
					<!-- <v-select append-to-body label="partNumber" :options="partDestinations"  :value="filterDeliveryOrderDetail.partDestinationId" :reduce="item => item.id" v-model="filterDeliveryOrderDetail.partDestinationId" @search="getParts" :filterable="true"></v-select> -->
				</b-th>
				<b-th stacked-heading="Delivery Date">
					<b-form-datepicker boundary="viewport" placeholder="" id="input-delivery-date-from-table" v-model="filterDeliveryOrderDetail.deliveryDateFrom" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button></b-form-datepicker>
					<b-form-datepicker boundary="viewport" placeholder="" id="input-delivery-date-to-table" v-model="filterDeliveryOrderDetail.deliveryDateTo" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button></b-form-datepicker>
				</b-th>
				<!-- <b-th stacked-heading="Delivery Status">
					<v-select append-to-body label="name" :options="deliveryStatuss"  :value="filterDeliveryOrderDetail.deliveryStatusId" :reduce="item => item.id" v-model="filterDeliveryOrderDetail.deliveryStatusId" @search="getDeliveryStatuss" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="DO Progress Status">
					<v-select append-to-body label="name" :options="doProgressStatuss"  :value="filterDeliveryOrderDetail.doProgressStatusId" :reduce="item => item.id" v-model="filterDeliveryOrderDetail.doProgressStatusId" @search="getDoProgressStatuss" :filterable="true"></v-select>
				</b-th> -->

				<b-th></b-th>
			</template>
			<template v-slot:head(frontActions)>
				<b-button @click="isShowDeliveryOrderDetailFilter = !isShowDeliveryOrderDetailFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( deliveryOrderDetailPageSize * (currentDeliveryOrderDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(poNumber)="row">
				<app-input-textbox :id="'input-delivery-order-details-po-number-' + row.index" label-cols-lg="12" label="PO Number" size="sm" :model.sync="row.item.poNumber"   @change="saveInputDeliveryOrderDetail(row.item)"  :isUpdatable="true"  :isEditable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-delivery-order-details-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputDeliveryOrderDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"   :isUpdatable="true" :isEditable="false"  :nolabel="true" />
			</template>
			<template v-slot:cell(qtyPerUnit)="row">
				<app-input-textbox :id="'input-delivery-order-details-qty-per-unit-' + row.index" label-cols-lg="12" label="QtyPerUnit" size="sm" :model.sync="row.item.qtyPerUnit"   @change="saveInputDeliveryOrderDetail(row.item)"  :isUpdatable="true" :isEditable="true"  :nolabel="true" />
			</template>
			<template v-slot:cell(uom)="row">
				<app-label label-cols-lg="12" size="sm" label="Uom" :model="(row.item.part != null) ? (row.item.part.uom != null) ? row.item.part.uom.code : null : null"  />
			</template>
			<template v-slot:cell(partDestination)="row">
				<app-input-combobox-autocomplete :options="partDestinations" optionsLabel="destinationCode" optionsKey="id" :id="'input-delivery-order-details-part-destination-' + row.index" label-cols-lg="12" label="Part Destination" size="sm" :model.sync="row.item.partDestinationId"  @change="saveInputDeliveryOrderDetail(row.item)" :selected="row.item.partDestination != null ? row.item.partDestination.destinationCode : ''"  @input="getPartDestinations(row.item)" :loading="isPartDestinationComboLoading" :isUpdatable="true" :isEditable="true" :nolabel="true" />
			</template>
			<template v-slot:cell(deliveryDate)="row">
				<app-input-datepicker  :id="'input-delivery-order-details-delivery-date-' + row.index + '-' + row.item.id" label-cols-lg="12" label="Delivery Date" size="sm" :model.sync="row.item.deliveryDate"   @change="onDateChange(row.item)"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isUpdatable="true" :isEditable="true" :nolabel="true"  />
			</template>
			<!-- <template v-slot:cell(deliveryStatus)="row">
				<app-input-combobox-autocomplete :options="deliveryStatuss" optionsLabel="name" optionsKey="id" :id="'input-delivery-order-details-delivery-status-' + row.index" label-cols-lg="12" label="Delivery Status" size="sm" :model.sync="row.item.deliveryStatusId"  @change="saveInputDeliveryOrderDetail(row.item)" :selected="row.item.deliveryStatus != null ? row.item.deliveryStatus.name : ''"  @input="getDeliveryStatuss" :loading="isDeliveryStatusComboLoading"   :isUpdatable="true" :isEditable="false"  :nolabel="true" />
			</template>
			<template v-slot:cell(doProgressStatus)="row">
				<app-input-combobox-autocomplete :options="doProgressStatuss" optionsLabel="name" optionsKey="id" :id="'input-delivery-order-details-do-progress-status-' + row.index" label-cols-lg="12" label="DO Progress Status" size="sm" :model.sync="row.item.doProgressStatusId"  @change="saveInputDeliveryOrderDetail(row.item)" :selected="row.item.doProgressStatus != null ? row.item.doProgressStatus.name : ''"  @input="getDoProgressStatuss" :loading="isDoProgressStatusComboLoading"   :isUpdatable="true" :isEditable="false"  :nolabel="true" />
			</template> -->

			<template v-slot:form-add-detail>
				<DeliveryOrderDetailInput 
					:openPopup="isShowPopupDeliveryOrderDetail"
					:modelId="deliveryOrderDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataDeliveryOrderDetail"/>
			</template>
			<template v-slot:upload-detail>
				<DeliveryOrderDetailUploadFromDetail
					:openPopup="isShowPopupUploadDeliveryOrderDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataDeliveryOrderDetail"
					:parentId="modelId"
					/>
			</template>
			<!-- <template #row-details="row">
				<b-card>
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-delivery-order-details-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputDeliveryOrderDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-delivery-order-details-qty-per-unit-' + row.index" label-cols-lg="12" label="QtyPerUnit" size="sm" :model.sync="row.item.qtyPerUnit"   @change="saveInputDeliveryOrderDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-datepicker  :id="'input-delivery-order-details-delivery-date-' + row.index" label-cols-lg="12" label="Delivery Date" size="sm" :model.sync="row.item.deliveryDate"   @change="onDateChange(row.item)" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" :isUpdatable="false" :isEditable="false"   />
					<app-input-combobox-autocomplete :options="deliveryStatuss" optionsLabel="name" optionsKey="id" :id="'input-delivery-order-details-delivery-status-' + row.index" label-cols-lg="12" label="Delivery Status" size="sm" :model.sync="row.item.deliveryStatusId"  @change="saveInputDeliveryOrderDetail(row.item)" :selected="row.item.deliveryStatus != null ? row.item.deliveryStatus.name : ''"  @input="getDeliveryStatuss" :loading="isDeliveryStatusComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-input-combobox-autocomplete :options="doProgressStatuss" optionsLabel="name" optionsKey="id" :id="'input-delivery-order-details-do-progress-status-' + row.index" label-cols-lg="12" label="DO Progress Status" size="sm" :model.sync="row.item.doProgressStatusId"  @change="saveInputDeliveryOrderDetail(row.item)" :selected="row.item.doProgressStatus != null ? row.item.doProgressStatus.name : ''"  @input="getDoProgressStatuss" :loading="isDoProgressStatusComboLoading"  :isUpdatable="false" :isEditable="false"  />
				</b-card>
			</template> -->

			<template #table-paging>
				<b-row>
					<b-col cols="12" class="paging-container">
						<div>
							<b-row>
								<b-col cols="12" class="paging-item">
									<b-pagination class="btn-paging paging-page-size float-right"
										v-model="currentDeliveryOrderDetailPage"
										:total-rows="(deliveryOrderDetailsPaging != null ? deliveryOrderDetailsPaging.dataCount : 0)"
										:per-page="(deliveryOrderDetailsPaging != null ? deliveryOrderDetailsPaging.pageSize : 0)"
										aria-controls="table-input">
										<template #first-text>
											<b-icon-chevron-left />
										</template>
										<template #prev-text>
											Prev
										</template>
										<template #next-text>
											Next
										</template>
										<template #last-text>
											<b-icon-chevron-right />
										</template>
									</b-pagination>
									<span class="paging-page-size float-right">
										<b-form-select v-if="false" v-model="deliveryOrderDetailPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
										<b-dropdown :text="deliveryOrderDetailPageSize + ' per page'" class="m-md-2 btn-paging-size" size="sm">
											<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="deliveryOrderDetailPageSize = item.value">
												{{ item.text }}
											</b-dropdown-item>
										</b-dropdown>
									</span>
								</b-col>
							</b-row>
						</div>
					</b-col>
				</b-row>
			</template>

		</app-table-input-popup>
        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<style scoped>
	.paging-item {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}
</style>
<script>
//import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import DeliveryOrder from '@/models/DeliveryOrder/DeliveryOrder';
//import DeliveryOrderList from '@/models/DeliveryOrder/DeliveryOrderList';
import DeliveryOrderFilter from '@/filters/DeliveryOrder/DeliveryOrderFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppLabel from '@/components/AppLabel';
import AppInputDatepicker from '@/components/AppInputDatepicker';
//import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import DeliveryOrderStatus from '@/models/DeliveryOrderStatus/DeliveryOrderStatus';
import DeliveryOrderStatusFilter from '@/filters/DeliveryOrderStatus/DeliveryOrderStatusFilter';
import Customer from '@/models/Customer/Customer';
import CustomerFilter from '@/filters/Customer/CustomerFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import DeliveryOrderDetail from '@/models/DeliveryOrder/DeliveryOrderDetail';
import DeliveryOrderDetailFilter from '@/filters/DeliveryOrder/DeliveryOrderDetailFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import Uom from '@/models/Uom/Uom';
import UomFilter from '@/filters/Uom/UomFilter';
import PurchaseOrderDetail from '@/models/PurchaseOrder/PurchaseOrderDetail';
import PurchaseOrderDetailFilter from '@/filters/PurchaseOrder/PurchaseOrderDetailFilter';
import DeliveryStatus from '@/models/DeliveryStatus/DeliveryStatus';
import DeliveryStatusFilter from '@/filters/DeliveryStatus/DeliveryStatusFilter';
import DoProgressStatus from '@/models/DoProgressStatus/DoProgressStatus';
import DoProgressStatusFilter from '@/filters/DoProgressStatus/DoProgressStatusFilter';
//import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import DeliveryOrderDetailInput from '@/views/DeliveryOrder/DeliveryOrderDetailInput';
import DeliveryOrderDetailUploadFromDetail from '@/views/DeliveryOrder/DeliveryOrderDetailUploadFromDetail';
//import PopupRouterView from '@/components/PopupRouterView';
import PartDestination from '@/models/PartDestination/PartDestination';
import PartDestinationFilter from '@/filters/PartDestination/PartDestinationFilter';
export default {
	components : {
		AppLabel,
		AppInputDatepicker,
		//AppInputDatepickerRange,
		AppInputComboboxAutocomplete,
		AppInputTextarea,
		AppInputTextbox,
		DeliveryOrderDetailInput,DeliveryOrderDetailUploadFromDetail,
		//AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		//PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			doDate: {required},
			customerId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				doDate: { required : "DO Date is Required."},
				customerId: { required : "Customer is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsDeliveryOrderDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"poNumber": { "class" : "th-po-number first-child", "label" : "PO Number", key: 'poNumber', sortable: false}}, 
				{"part": { "class" : "th-part", "label" : "Part", key: 'part', sortable: false}}, 
				{"qtyPerUnit": { "class" : "th-qty-per-unit last-child", "label" : "Qty/Unit", key: 'qtyPerUnit', sortable: false}}, 
				{"uom": { "class" : "th-uom", "label" : "Uom", key: 'part.uom.code', sortable: false}}, 
				{"partDestination": { "class" : "th-part-destination", "label" : "Part Destination", key: 'partDestination', sortable: false}}, 
				{"deliveryDate": { "class" : "th-delivery-date d-stack-none", "label" : "Delivery Date", key: 'deliveryDate', sortable: false}}, 
				// {"deliveryStatus": { "class" : "th-delivery-status d-stack-none", "label" : "Delivery Status", key: 'deliveryStatus', sortable: false}}, 
				// {"doProgressStatus": { "class" : "th-do-progress-status d-stack-none", "label" : "DO Progress Status", key: 'doProgressStatus', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelDeliveryOrderDetail : {},
			isShowPopupDeliveryOrderDetail : false,
			isShowPopupUploadDeliveryOrderDetail : false,
			filterDeliveryOrder : null,
			currentDeliveryOrderPage : 1,
			deliveryOrderPageSize: 10,
			sortByDeliveryOrder: '',
			sortDescDeliveryOrder: '',
			filterDeliveryOrderDetail : null,
			currentDeliveryOrderDetailPage : 1,
			deliveryOrderDetailPageSize: 10,
			sortByDeliveryOrderDetail: '',
			sortDescDeliveryOrderDetail: '',
			sortingByDeliveryOrderDetail: [],
			deliveryOrderDetails : [],
			deliveryOrderDetailId : '',
			totalDeliveryOrderDetailRow : 0,
			isShowDeliveryOrderDetailFilter: false,
			isDownloadDeliveryOrderDetail: false,
			parts: [],
			deliveryStatuss: [],
			doProgressStatuss: [],
			deliveryOrderStatuss: [],
			isDeliveryOrderStatusComboLoading: false,
			customers: [],
			isCustomerComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isDeliveryOrderComboLoading: false,
			isPartComboLoading: false,
			isPurchaseOrderDetailComboLoading: false,
			isDeliveryStatusComboLoading: false,
			isDoProgressStatusComboLoading: false,
			isChangingDate: false,
			isPartDestinationComboLoading: false,
			deliveryOrderDetailsPaging: {},
			partDestinations: [],
			partDestionationsForFilter: [],
			uoms: [],
			partDestinationsForFilter: [],
		}
	},
	methods : {
		async onDateChange(item) {
            if (!this.isChangingDate) {
                this.isChangingDate = true;
                await this.saveInputDeliveryOrderDetail(item);
                this.isChangingDate = false;
            }
        },
		getDeliveryOrder : async function(id) {
			this.isBusy = true;
			DeliveryOrder.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadDeliveryOrder = true;
			this.filterDeliveryOrder.id = this.modelId;
			DeliveryOrder.downloadDataDetail(this, this.filterDeliveryOrder).then(result => {
				this.isDownloadDeliveryOrder = false;
			}).catch(error => { this.isDownloadDeliveryOrder = false; })
		},
		getDeliveryOrderDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterDeliveryOrderDetail);
			if (this.modelId == null) return;
			filter.deliveryOrderId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByDeliveryOrderDetail != null) {
				this.sortingByDeliveryOrderDetail[this.sortByDeliveryOrderDetail] = this.sortDescDeliveryOrderDetail;
			}
			let currentPage = (this.currentDeliveryOrderDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalDeliveryOrderDetailRow + 1;
				let page = Math.ceil(totalData/this.deliveryOrderDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			//currentPage = 1;
			//this.deliveryOrderDetailPageSize = 10;
			// disable paging end
			await DeliveryOrderDetail.getList(this, filter, this.sortingByDeliveryOrderDetail, currentPage , this.deliveryOrderDetailPageSize).then(result => {
				this.currentDeliveryOrderDetailPage = currentPage + 1;
				this.deliveryOrderDetails = result.data;
				this.totalDeliveryOrderDetailRow = result.dataCount;
				this.deliveryOrderDetailsPaging = result
			}).catch(error => {});
		},
		getDeliveryOrders : async function(input) {
			let filter = new DeliveryOrderFilter();
			if (input != undefined) {
				filter.DoNumber = input;
			}
			this.isDeliveryOrderComboLoading = true;
			await DeliveryOrder.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryOrders = result.data
				}
				this.isDeliveryOrderComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getPartDestinations : async function(item) {
			if (this.model.customerId == undefined || this.model.customerId == null || this.model.customerId == '' || item.partId == undefined || item.partId == null || item.partId == '') return;
			let filter = new PartDestinationFilter();
			// if (input != undefined) {
			// 	filter.destinationCode = input;
			// }
			filter.partId = item.partId;
			filter.customerId = this.model.customerId;
			this.isPartDestinationComboLoading = true;
			PartDestination.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partDestinations = result.data
				}
				this.isPartDestinationComboLoading = false;
			})
			.catch(error => {});
		},
		getPartDestinationsForFilter : async function(input) {
			if (this.model.customerId == undefined || this.model.customerId == null || this.model.customerId == '') return;
			let filter = new PartDestinationFilter();
			if (input != undefined) {
				filter.destinationCode = input;
			}
			filter.customerId = this.model.customerId;
			this.isPartDestinationComboLoading = true;
			PartDestination.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partDestinationsForFilter = result.data
				}
				this.isPartDestinationComboLoading = false;
			})
			.catch(error => {});
		},
		getUoms : async function(input) {
			let filter = new UomFilter();
			if (input != undefined) {
				filter.code = input;
			}
			this.isUomComboLoading = true;
			Uom.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.uoms = result.data
				}
				this.isUomComboLoading = false;
			})
			.catch(error => {});
		},
		getPurchaseOrderDetails : async function(input) {
			let filter = new PurchaseOrderDetailFilter();
			if (input != undefined) {
				filter.qtyPo = input;
			}
			this.isPurchaseOrderDetailComboLoading = true;
			PurchaseOrderDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.purchaseOrderDetails = result.data
				}
				this.isPurchaseOrderDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryStatuss : async function(input) {
			let filter = new DeliveryStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isDeliveryStatusComboLoading = true;
			DeliveryStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryStatuss = result.data
				}
				this.isDeliveryStatusComboLoading = false;
			})
			.catch(error => {});
		},
		getDoProgressStatuss : async function(input) {
			let filter = new DoProgressStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isDoProgressStatusComboLoading = true;
			DoProgressStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.doProgressStatuss = result.data
				}
				this.isDoProgressStatusComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryOrderStatuss : async function(input) {
			let filter = new DeliveryOrderStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			DeliveryOrderStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryOrderStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDeliveryOrderStatus(item) {
			if(item == undefined || item == null) {
				this.model.deliveryOrderStatusId = null;
				this.model.deliveryOrderStatus = null;
			} else {
				this.model.deliveryOrderStatusId = item.id;
				this.model.deliveryOrderStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getCustomers : async function(input) {
			let filter = new CustomerFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Customer.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.customers = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedCustomer(item) {
			if(item == undefined || item == null) {
				this.model.customerId = null;
				this.model.customer = null;
			} else {
				this.model.customerId = item.id;
				this.model.customer = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.deliveryOrderInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					DeliveryOrder.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'deliveryorderindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					DeliveryOrder.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'deliveryorderindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					DeliveryOrder.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getDeliveryOrder(id);
					});
				}
			});
		},
		onHidden() {
			this.getDeliveryOrders();
		},
		addRowDataDeliveryOrderDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.deliveryOrderId =  this.modelId;
					DeliveryOrderDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getDeliveryOrderDetails(true);
						this.isShowPopupDeliveryOrderDetail = false;
					})
				} else {
					model.deliveryOrderId =  this.modelId;
					DeliveryOrderDetail.createDataDetail(this, model)
					.then(result => {
						this.getDeliveryOrderDetails(true);
						this.isShowPopupDeliveryOrderDetail = false;
					})
				}
			}
		},
		async editRowDataDeliveryOrderDetail(id) {
			this.deliveryOrderDetailId = id;
			this.isShowPopupDeliveryOrderDetail = true; 
		},
		async deleteRowDataDeliveryOrderDetail(id) {
			let this_ = this;
			this.isDataLoading = true;
			// DeliveryOrderDetail.deleteData(this, id).then(result => {  });
			try {
				await this_.$http.delete('deliveryorderdetail/deleteFromDetail/' + id, []);
				await this_.getDeliveryOrderDetails();
				this_.isDataLoading = false;
			} catch (error) {
				this_.isDataLoading = false;
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			}
		},
		async resetDataDeliveryOrderDetail() {
			this.deliveryOrderDetailId = "";
			this.isShowPopupDeliveryOrderDetail = true;
		},
		async addDataDeliveryOrderDetail() {
			DeliveryOrderDetail.createData(this, { deliveryOrderId: this.modelId })
			.then(result => {
				this.getDeliveryOrderDetails(true);
			})
		},
		async addFromClipboardDeliveryOrderDetail() {
			let poNumbers = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					poNumbers.push({ poNumber: item, deliveryOrderId: this.modelId });
				});
				DeliveryOrderDetail.addFromClipboard(this, poNumbers).then(result => { this.getDeliveryOrderDetails() });
			});
		},
		async replaceFromClipboardDeliveryOrderDetail() {
			let poNumbers = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					poNumbers.push({ poNumber: item, deliveryOrderId: this.modelId });
				});
				DeliveryOrderDetail.replaceFromClipboard(this, poNumbers).then(result => { this.getDeliveryOrderDetails() });
			});   
		},
		showPopupUploadDeliveryOrderDetail() {
			if(this.deliveryOrderDetails != null && this.deliveryOrderDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
                        innerHTML: '<p>Perubahan terhadap Delivery Order Detail hanya boleh dilakukan pada \"PO Number\", \"Part Destination\", \"QtyperUnit\",dan \"Delivery Date\". Perubahan yang lain akan diabaikan</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadDeliveryOrderDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadDeliveryOrderDetail = true;
			}
		},
		uploadDataDeliveryOrderDetail(modalEvent, newDatas) {
			this.isShowPopupUploadDeliveryOrderDetail = false; 
		},
		downloadDeliveryOrderDetail(modalEvent) {
			this.isDownloadDeliveryOrderDetail = true;
			this.filterDeliveryOrderDetail.deliveryOrderId = this.modelId;
			DeliveryOrderDetail.downloadDataDetail(this, this.filterDeliveryOrderDetail).then(result => {
				this.isDownloadDeliveryOrderDetail = false;
			}).catch(error => { this.isDownloadDeliveryOrderDetail = false; })
		},
		async saveInputDeliveryOrderDetail(item) {
			this.isDataLoading = true;
			if (this.deliveryOrders != null && this.deliveryOrders != undefined  && this.deliveryOrders.length > 0) {
				item.deliveryOrder = this.deliveryOrders.find(q => q.id == item.deliveryOrderId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0 && this.parts.find(q => q.id == item.partId)) {
				item.part = this.parts.find(q => q.id == item.partId);
			}
			// if (this.partDestinations != null && this.partDestinations != undefined  && this.partDestinations.length > 0 && this.partDestinations.find(q => q.id == item.partDestinationId)) {
			// 	item.partDestination = this.partDestinations.find(q => q.id == item.partDestinationId);
			// 	item.destinationId = item.partDestination.destinationId;
			// 	item.destination = item.partDestination.destination;
			// }
			if (this.purchaseOrderDetails != null && this.purchaseOrderDetails != undefined  && this.purchaseOrderDetails.length > 0) {
				item.poDetail = this.purchaseOrderDetails.find(q => q.id == item.poDetailId);
			}
			if (this.deliveryStatuss != null && this.deliveryStatuss != undefined  && this.deliveryStatuss.length > 0) {
				item.deliveryStatus = this.deliveryStatuss.find(q => q.id == item.deliveryStatusId);
			}
			if (this.doProgressStatuss != null && this.doProgressStatuss != undefined  && this.doProgressStatuss.length > 0) {
				item.doProgressStatus = this.doProgressStatuss.find(q => q.id == item.doProgressStatusId);
			}

			let id = item.id;
			let this_ = this;
			if (id != '' && id != null && id != undefined) {
				await DeliveryOrderDetail.updateDataDetail(this_, item, item.id)
				.catch(error => {
					this_.isDataLoading = false;
				});
			}
			this.getDeliveryOrderDetails();
			this.isDataLoading = false;
		},
		resetModal(modalType) {
			this.isShowPopupUploadDeliveryOrderDetail = false; 
			this.isShowPopupDeliveryOrderDetail = false; 
			if (modalType == 'DeliveryOrderDetail') {
				this.getDeliveryOrderDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowDeliveryOrderDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterDeliveryOrder = new DeliveryOrderFilter();
		this.filterDeliveryOrderDetail = new DeliveryOrderDetailFilter();
		//this.getDeliveryOrders();
		this.getParts();
		this.getPartDestinationsForFilter();
		this.getUoms();
		//this.getPurchaseOrderDetails();
		//this.getDeliveryStatuss();
		//this.getDoProgressStatuss();
		//this.getDeliveryOrderStatuss();
		//this.getCustomers();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getDeliveryOrder(id);
			} else {
				this.modelId = id;
				this.getDeliveryOrder(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
		sortByDeliveryOrderDetail : {
			handler: function() {
				this.getDeliveryOrderDetails();
			}
		},
		sortDescDeliveryOrderDetail: {
			handler: function() {
				this.getDeliveryOrderDetails();
			}
		},
		currentDeliveryOrderDetailPage: {
			handler: async function() {
				await this.getDeliveryOrderDetails();
			}
		},
		deliveryOrderDetailPageSize : {
			handler: async function() {
				await this.getDeliveryOrderDetails();
			}
		},
		filterDeliveryOrderDetail: {
			handler: async function() {
				await this.getDeliveryOrderDetails();
			},
			deep: true,
		},
	},
}
</script>
